// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-GwCx","twoButtons":"styles_twoButtons__ngBDo"};